import { CompanyType } from "$types/CompanyType";

const { AGENCY, CARRIER, CLIENT, CONTRIBUTOR, LOGISTICIAN, SUPPLIER } =
  CompanyType;

const COMPANY_TYPE_LABELS = {
  [AGENCY]: "Agence transporteur",
  [CARRIER]: "Transporteur",
  [CLIENT]: "Client",
  [CONTRIBUTOR]: "Intervenant",
  [LOGISTICIAN]: "Logisticien",
  [SUPPLIER]: "Fournisseur",
};

// see src/index.tsx for the available colors
const COMPANY_TYPE_COLORS = {
  [AGENCY]: "blueLight2",
  [CARRIER]: "blueSapphire",
  [CLIENT]: "orange",
  [CONTRIBUTOR]: "blueLight",
  [LOGISTICIAN]: "red",
  [SUPPLIER]: "silverPale",
};

export enum SIRET_ADDRESS {
  AIRE = "AIRE",
  ALL = "ALLÉE",
  AV = "AVENUE",
  BASE = "BASE",
  BD = "BOULEVARD",
  CAMI = "CAMI",
  CAR = "CARREFOUR",
  CHE = "CHEMIN",
  CHEM = "CHEMINEMENT",
  CHS = "CHAUSSÉE",
  CITE = "CITÉ",
  CLOS = "CLOS",
  COIN = "COIN",
  COR = "CORNICHE",
  COTE = "COTE",
  COUR = "COUR",
  CRS = "COURS",
  DOM = "DOMAINE",
  DSC = "DESCENTE",
  ECA = "ÉCART",
  ESP = "ESPLANADE",
  FG = "FAUBOURG",
  GARE = "GARE",
  GR = "GRANDE RUE",
  HAM = "HAMEAU",
  HLE = "HALLE",
  ILOT = "ILÔT",
  IMP = "IMPASSE",
  LD = "LIEU DIT",
  LOT = "LOTISSEMENT",
  MAR = "MARCHÉ",
  MTE = "MONTÉE",
  PARC = "PARC",
  PAS = "PASSAGE",
  PL = "PLACE",
  PLAN = "PLAN",
  PLN = "PLAINE",
  PLT = "PLATEAU",
  PONT = "PONT",
  PORT = "PORT",
  PRO = "PROMENADE",
  PRV = "PARVIS",
  QUA = "QUARTIER",
  QUAI = "QUAI",
  RES = "RÉSIDENCE",
  RLE = "RUELLE",
  ROC = "ROCADE",
  RPT = "ROND POINT",
  RTE = "ROUTE",
  RUE = "RUE",
  SEN = "SENTIER",
  SQ = "SQUARE",
  TOUR = "TOUR",
  TPL = "TERRE-PLEIN",
  TRA = "TRAVERSE",
  VLA = "VILLA",
  VLGE = "VILLAGE",
  VOIE = "VOIE",
  ZA = "ZA",
  ZAC = "ZAC",
  ZAD = "ZAD",
  ZI = "ZI",
  ZONE = "ZONE",
}

export const getCompanyTypeLabel = (companyType: CompanyType): string =>
  COMPANY_TYPE_LABELS[companyType];

export const companyTypesOptions = Object.values(CompanyType)
  .map((companyType) => ({
    value: companyType,
    label: COMPANY_TYPE_LABELS[companyType],
  }))
  .sort((a1, a2) => a1.label.localeCompare(a2.label));

/**
 * @param {CompanyType} companyType
 * @param {any} theme from createUseStyles()
 * @returns {string}
 */
export const getCompanyTypeColor = (
  companyType: CompanyType,
  theme: any
): string => {
  return theme.color[COMPANY_TYPE_COLORS[companyType]];
};
